module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bak-color"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "services"
  }, [_c('h3', [_vm._v("Devices Contributing Pollution Data")]), _vm._v(" "), _c('ul', {
    staticClass: "col-xs-12"
  }, [_c('li', {
    staticClass: "col-lg-6 col-xs-6"
  }, [_c('a', {
    attrs: {
      "href": "http://originstech.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/origins.png"),
      "alt": "Origins Laser Egg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://originstech.com/",
      "target": "_blank"
    }
  }, [_c('h6', [_vm._v("Origins Laser Egg")])])]), _vm._v(" "), _c('li', {
    staticClass: "col-lg-6 col-xs-6"
  }, [_c('a', {
    attrs: {
      "href": "https://airvisual.com/node",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/airvisual.png"),
      "alt": "AirVisual Node"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://airvisual.com/node",
      "target": "_blank"
    }
  }, [_c('h6', [_vm._v("AirVisual Node")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4078e790"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AirVisual.vue
// module id = 304
// module chunks = 1